import * as React from 'react';
import {FormControl, Grid, InputLabel, MenuItem, Select, TextField} from "@material-ui/core";
import DemographicProfileFieldsSection from "../DemographicProfileFieldsSection";
import {Alert} from "@material-ui/lab";
import {Frequencies, Programs} from "../../../../../consts/PacMan";
import { getDateOfBirth, getUniqueName } from '../../../../../utils/RandomDemographicInfoGen';

interface IProps {
    data?: any
}

interface IState {
    intervalDays: string
    program: string
    scheduleFrequency: string
}

class CustomerWithContractSection extends React.Component<IProps, IState> {
    private demographicProfileFieldsSection: any;

    constructor(props: IProps) {
        super(props);

        this.state = {
            intervalDays: '1',
            program: Programs.HUBS,
            scheduleFrequency: Frequencies.ONE_TIME
        }

        this.handleProgram = this.handleProgram.bind(this);
        this.handleScheduleFrequency = this.handleScheduleFrequency.bind(this);
        this.handleIntervalDays = this.handleIntervalDays.bind(this);
    };

    public render() {
        return (
            <Grid item xs={12}>
                <Grid
                    container
                    direction="column"
                    justify="center"
                    alignItems="center"
                    spacing={3}
                >
                    <Alert variant="filled" severity="info">
                        Please note that the contract creation process is asynchronous and can take up to 2 minutes for
                        a contract to be created.
                    </Alert>

                    <DemographicProfileFieldsSection ref={(ref) => this.demographicProfileFieldsSection = ref}
                                                 forCheckout={true}/>

                    <Grid item xs>
                        <InputLabel style={{
                            color: "red",
                            fontSize: 18,
                            fontWeight: "bold",
                        }}>Enrollment Options</InputLabel>
                    </Grid>

                    <Grid item xs>
                        <FormControl>
                            <InputLabel>Program Name</InputLabel>
                            <Select
                                value={this.state.program}
                                style={{width: 225}}
                                onChange={this.handleProgram}
                            >
                                {Object.keys(Programs).map(program => (
                                    <MenuItem value={program}>
                                        <em>{program}</em>
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs>
                        <FormControl>
                            <InputLabel>Schedule Frequency</InputLabel>
                            <Select
                                value={this.state.scheduleFrequency}
                                style={{width: 225}}
                                onChange={this.handleScheduleFrequency}
                            >
                                {Object.keys(Frequencies).map(frequency => (
                                    <MenuItem value={frequency}>
                                        <em>{frequency}</em>
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    {this.state.scheduleFrequency !== Frequencies.ONE_TIME && <Grid item xs>
                        <TextField
                            style={{width: 225}}
                            type="number"
                            label="Interval Days"
                            variant="outlined"
                            value={ this.state.intervalDays }
                            onChange={ this.handleIntervalDays }
                        />
                    </Grid>}
                </Grid>
            </Grid>
        )
    }

    public getRequest() {
        const enrollmentOptions = {
            intervalDays: this.state.intervalDays,
            programName: this.state.program,
            scheduleFrequency: this.state.scheduleFrequency
        }

        return {
            body: {
                actorSubType: this.demographicProfileFieldsSection.getBasicFieldsSection().actorSubType,
                addInsurancePlan: this.demographicProfileFieldsSection.getHealthProfileFieldsSection().getState().addInsurancePlan,
                binNumber: this.demographicProfileFieldsSection.getHealthProfileFieldsSection().getState().binNumber,
                binNumber2: this.demographicProfileFieldsSection.getHealthProfileFieldsSection().getState().binNumber2,
                binNumber3: this.demographicProfileFieldsSection.getHealthProfileFieldsSection().getState().binNumber3,
                cardHolderId: this.demographicProfileFieldsSection.getHealthProfileFieldsSection().getState().cardHolderId,
                cardHolderId2: this.demographicProfileFieldsSection.getHealthProfileFieldsSection().getState().cardHolderId2,
                cardHolderId3: this.demographicProfileFieldsSection.getHealthProfileFieldsSection().getState().cardHolderId3,
                commonAllergies: this.demographicProfileFieldsSection.getHealthProfileFieldsSection().getState().commonAllergies,
                commonHealthConditions: this.demographicProfileFieldsSection.getHealthProfileFieldsSection().getState().commonHealthConditions,
                completeScriptChase: (this.demographicProfileFieldsSection.getHealthProfileFieldsSection().getState().medicationList.length > 0 ? this.demographicProfileFieldsSection.getHealthProfileFieldsSection().getCheckoutFieldsSection().getState().completeScriptChase : null),
                creditCard: this.demographicProfileFieldsSection.getBasicFieldsSection().getState().creditCard,
                customerJourneyType: this.demographicProfileFieldsSection.getState().customerJourneyType,
                dateOfBirth: this.demographicProfileFieldsSection.getState().dateOfBirth == "" ? getDateOfBirth(Math.random(), -1000) : this.demographicProfileFieldsSection.getState().dateOfBirth,
                daysSupply: (this.demographicProfileFieldsSection.getHealthProfileFieldsSection().getState().medicationList.length > 0 ? this.demographicProfileFieldsSection.getHealthProfileFieldsSection().getCheckoutFieldsSection().getState().daysSupply : null),
                dispenseDaysSupply: (this.demographicProfileFieldsSection.getHealthProfileFieldsSection().getState().medicationList.length > 0 ? this.demographicProfileFieldsSection.getHealthProfileFieldsSection().getCheckoutFieldsSection().getState().dispenseDaysSupply : null),
                dispenseQuantity: (this.demographicProfileFieldsSection.getHealthProfileFieldsSection().getState().medicationList.length > 0 ? this.demographicProfileFieldsSection.getHealthProfileFieldsSection().getCheckoutFieldsSection().getState().dispenseQuantity : null),
                emailPrefix: this.demographicProfileFieldsSection.getBasicFieldsSection().getState().emailPrefix,
                enrollmentOptions: { ...enrollmentOptions },
                expirationDate: (this.demographicProfileFieldsSection.getHealthProfileFieldsSection().getState().medicationList.length > 0 ? this.demographicProfileFieldsSection.getHealthProfileFieldsSection().getCheckoutFieldsSection().getState().expirationDate : null),
                fakeOutScriptChase: (this.demographicProfileFieldsSection.getHealthProfileFieldsSection().getState().medicationList.length > 0 ? this.demographicProfileFieldsSection.getHealthProfileFieldsSection().getCheckoutFieldsSection().getState().fakeOutScriptChase : null),
                forCheckout: true,
                gender: this.demographicProfileFieldsSection.getState().gender,
                giftCard: this.demographicProfileFieldsSection.getBasicFieldsSection().getState().giftCard,
                giftCardBalance: this.demographicProfileFieldsSection.getBasicFieldsSection().getState().giftCardBalance,
                groupNumber: this.demographicProfileFieldsSection.getHealthProfileFieldsSection().getState().groupNumber,
                groupNumber2: this.demographicProfileFieldsSection.getHealthProfileFieldsSection().getState().groupNumber2,
                groupNumber3: this.demographicProfileFieldsSection.getHealthProfileFieldsSection().getState().groupNumber3,
                identityValidationForKatara: this.demographicProfileFieldsSection.getState().identityValidationStatusKatara,
                identityValidationStatus: this.demographicProfileFieldsSection.getState().identityValidationStatus,
                initialRefills: (this.demographicProfileFieldsSection.getHealthProfileFieldsSection().getState().medicationList.length > 0 ? this.demographicProfileFieldsSection.getHealthProfileFieldsSection().getCheckoutFieldsSection().getState().refillsAuthorized : null),
                initiateScriptChase: (this.demographicProfileFieldsSection.getHealthProfileFieldsSection().getState().medicationList.length > 0 ? this.demographicProfileFieldsSection.getHealthProfileFieldsSection().getCheckoutFieldsSection().getState().initiateScriptChase : null),
                insurancePlan: this.demographicProfileFieldsSection.getHealthProfileFieldsSection().getState().insurancePlan,
                legalFirstName: this.demographicProfileFieldsSection.getState().legalFirstName == "" ? getUniqueName() : (this.demographicProfileFieldsSection.getState().legalFirstName),
                legalLastName: this.demographicProfileFieldsSection.getState().legalLastName == "" ? getUniqueName() : (this.demographicProfileFieldsSection.getState().legalLastName),
                medicationList: this.demographicProfileFieldsSection.getHealthProfileFieldsSection().getState().medicationList,
                middleName: this.demographicProfileFieldsSection.getState().middleName,
                name: this.demographicProfileFieldsSection.getBasicFieldsSection().getState().name,
                oneTimeFillReason: (this.demographicProfileFieldsSection.getHealthProfileFieldsSection().getState().medicationList.length > 0 ? this.demographicProfileFieldsSection.getHealthProfileFieldsSection().getCheckoutFieldsSection().getState().oneTimeFillReason : null),
                pcn: this.demographicProfileFieldsSection.getHealthProfileFieldsSection().getState().pcn,
                pcn2: this.demographicProfileFieldsSection.getHealthProfileFieldsSection().getState().pcn2,
                pcn3: this.demographicProfileFieldsSection.getHealthProfileFieldsSection().getState().pcn3,
                phoneNumber: this.demographicProfileFieldsSection.getBasicFieldsSection().getState().phone,
                pregnantOrNursing: (this.demographicProfileFieldsSection.getState().gender === 'Female' ? this.demographicProfileFieldsSection.getHealthProfileFieldsSection().getState().pregnantOrNursing : null),
                prime: this.demographicProfileFieldsSection.getBasicFieldsSection().getState().prime,
                programName: this.demographicProfileFieldsSection.getBasicFieldsSection().programName,
                quantityAuthorized: (this.demographicProfileFieldsSection.getHealthProfileFieldsSection().getState().medicationList.length > 0 ? this.demographicProfileFieldsSection.getHealthProfileFieldsSection().getCheckoutFieldsSection().getState().quantityAuthorized : null),
                quantityPerDay: this.demographicProfileFieldsSection.getHealthProfileFieldsSection().getCheckoutFieldsSection().getState().quantityPerDay,
                quantityPerDose: this.demographicProfileFieldsSection.getHealthProfileFieldsSection().getCheckoutFieldsSection().getState().quantityPerDose,
                residentialAddressId: this.demographicProfileFieldsSection.getState().residentialAddressId,
                rxPassForceActive: this.demographicProfileFieldsSection.getBasicFieldsSection().getState().rxPassForceActive,
                rxPassSubscription: this.demographicProfileFieldsSection.getBasicFieldsSection().getState().rxPassSubscription,
                setDefaultAddress: this.demographicProfileFieldsSection.getState().setDefaultAddress,
                setInsuranceAsPrimary: this.demographicProfileFieldsSection.getHealthProfileFieldsSection().getState().setInsuranceAsPrimary,
                setInsuranceAsPrimary2: this.demographicProfileFieldsSection.getHealthProfileFieldsSection().getState().setInsuranceAsPrimary2,
                setInsuranceAsPrimary3: this.demographicProfileFieldsSection.getHealthProfileFieldsSection().getState().setInsuranceAsPrimary3,
                source: 'MANUAL',
                spi: this.demographicProfileFieldsSection.getHealthProfileFieldsSection().getState().spi,
                ssn: this.demographicProfileFieldsSection.getState().ssn,
                staleHealthProfile: this.demographicProfileFieldsSection.getHealthProfileFieldsSection().getState().staleHealthProfile,
                status: (this.demographicProfileFieldsSection.getHealthProfileFieldsSection().getState().medicationList.length > 0 ? this.demographicProfileFieldsSection.getHealthProfileFieldsSection().getCheckoutFieldsSection().getState().status : null),
                suffix: this.demographicProfileFieldsSection.getState().suffix,
                withContract: true,
            },
            headers: {}
        }
    }

    private handleProgram(event: React.ChangeEvent<HTMLTextAreaElement>) {
        this.setState({program: event.target.value});
    }

    private handleScheduleFrequency(event: React.ChangeEvent<HTMLTextAreaElement>) {
        this.setState({scheduleFrequency: event.target.value});
    }

    private handleIntervalDays(event: React.ChangeEvent<HTMLTextAreaElement>) {
        this.setState({intervalDays: event.target.value});
    }
}

export default CustomerWithContractSection;